import { useTranslation } from 'next-i18next';
import { Icon } from '@bridebook/aura';
import { HeartOutline } from '@bridebook/aura/src/icons';
import { Box, colors } from '@bridebook/ui';
import { BudgetIcon, ChecklistIcon, GuestlistIcon } from '@bridebook/ui/src/icons';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import componentStyles from './planning-section.style';

const PlanningSection = () => {
  const { t } = useTranslation('articles');
  const styles = componentStyles();

  const planningData = [
    {
      icon: <ChecklistIcon width={18} color={colors.teal120} />,
      color: colors.teal20,
      title: t('checklist.title'),
      subtitle: t('trackProgress'),
    },
    {
      icon: <BudgetIcon width={18} color={colors.indigoCrush} />,
      color: colors.indigoCrush04,
      title: t('budget.title'),
      subtitle: t('checkBudget'),
    },
    {
      icon: <GuestlistIcon width={18} color={colors.peachRose120} />,
      color: colors.peachRose20,
      title: t('guestList.title'),
      subtitle: t('manageGuest'),
    },
    {
      icon: <Icon icon={HeartOutline} size={22} className="text-blush-tangerine-120" />,
      color: colors.pinkJoy60,
      title: t('favourites.title'),
      subtitle: t('shortlistFavourites'),
    },
  ];

  return (
    <Box>
      <Box>{t('plan.for.free')}</Box>
      <Box mt={2}>
        {planningData.map((feature) => (
          <SignupLink key={feature.title}>
            <Box style={styles.featureWrapper}>
              <Box style={styles.featureIcon(feature.color)}>{feature.icon}</Box>
              <Box ml={4}>
                <Box style={styles.title}>{feature.title}</Box>
                <Box style={styles.subTitle}>{feature.subtitle}</Box>
              </Box>
            </Box>
          </SignupLink>
        ))}
      </Box>
    </Box>
  );
};

export default PlanningSection;
